import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const RolesPage = lazy(() => import('~/features/organization/pages/roles-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/roles')({
  beforeLoad: requirePermission('organization_roles'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <RolesPage />
    </Suspense>
  ),
});
